import React from 'react';
import './App.css'; // or BeautyOfSriLanka.css
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const images = [
  '/images/new1.jpg',
  '/images/new2.jpg',
  '/images/new3.jpg',
  '/images/new4.jpg',
  '/images/new5.jpg',

];

const filteredImages = images.filter((img) => img && typeof img === 'string');

const BeautyOfSriLanka = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,               // Auto slide enabled
    autoplaySpeed: 2000,          // Slide every 3 seconds
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  return (
    <div className="beauty-container">
      <h2 className="beauty-heading">Feel the Breath of Nature at Cocoloco</h2>
      <Slider {...settings}>
        {filteredImages.map((src, index) => (
          <div key={index} className="image-slide">
            <img
              src={process.env.PUBLIC_URL + src}

              className="beauty-image"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default BeautyOfSriLanka;
